import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AddInspectionInput = {
  attachments: Array<Scalars['Upload']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  issues: Array<InspectionIssueInput>;
  matterportUrl: Scalars['String'];
  property?: Maybe<Scalars['ID']>;
  propertyManager?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
  youtubeUrl: Scalars['String'];
};

export type AttachFilesToPropertyInput = {
  documents: Array<Scalars['Upload']>;
  id: Scalars['ID'];
};

export type Attachment = {
  __typename?: 'Attachment';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type AuthUserPayload = {
  __typename?: 'AuthUserPayload';
  token: Scalars['String'];
  user: User;
};

export type Chat = {
  __typename?: 'Chat';
  id: Scalars['ID'];
  messages: Array<Message>;
  users: Array<User>;
};


export type ChatMessagesArgs = {
  first?: Maybe<Scalars['Int']>;
};

export type CheckPalaceConnectionInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type Company = {
  __typename?: 'Company';
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  offices?: Maybe<Array<Office>>;
  users: Array<User>;
};

export type CreateChatInput = {
  userId: Scalars['ID'];
};

export type CreateCompanyInput = {
  logo: Scalars['Upload'];
  name: Scalars['String'];
};

export type CreateMessageInput = {
  chatId: Scalars['ID'];
  message: Scalars['String'];
  plainText: Scalars['String'];
};

export type CreateOfficeInput = {
  address: Scalars['String'];
};

export type CreatePalaceInput = {
  officeId: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
  version?: Maybe<Scalars['String']>;
};

export type CustomField = {
  __typename?: 'CustomField';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type DocumentInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type Expense = {
  __typename?: 'Expense';
  accountType: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type HistoricalUserStatistics = {
  __typename?: 'HistoricalUserStatistics';
  count: Scalars['Float'];
  date: Scalars['String'];
  id: Scalars['ID'];
  office: Office;
  type: Scalars['String'];
  user: User;
};

export type Image = {
  __typename?: 'Image';
  title: Scalars['String'];
  url: Scalars['String'];
};

export type Inspection = {
  __typename?: 'Inspection';
  attachments?: Maybe<Array<Attachment>>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  issues: Array<InspectionIssue>;
  matterportUrl?: Maybe<Scalars['String']>;
  property: Property;
  propertyManager?: Maybe<PropertyManager>;
  type: Scalars['String'];
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type InspectionIssue = {
  __typename?: 'InspectionIssue';
  attachments: Array<Attachment>;
  description: Scalars['String'];
};

export type InspectionIssueInput = {
  attachments: Array<Scalars['Upload']>;
  description: Scalars['String'];
  uploadedAttachments?: Maybe<Array<DocumentInput>>;
};

export type InspectionsPayload = {
  __typename?: 'InspectionsPayload';
  inspections: Array<Inspection>;
  pagination: PaginationPayload;
};

export type Landlord = {
  __typename?: 'Landlord';
  currentBalance?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  propertyCount: Scalars['Float'];
  user: User;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Message = {
  __typename?: 'Message';
  chat: Chat;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isSeen?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
  plainText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type Mutation = {
  __typename?: 'Mutation';
  addInspection: Inspection;
  addMessageToChat: Message;
  attachFilesToProperty: Property;
  checkPalaceConnection: Scalars['Boolean'];
  createChat: Chat;
  createCompany: Company;
  createOffice: Office;
  createPalace: Palace;
  inviteUser: Scalars['Boolean'];
  login: AuthUserPayload;
  sendFrontendError: Scalars['Boolean'];
  sendHelpEnquiry: Scalars['Boolean'];
  sendResetPasswordEmail: Scalars['Boolean'];
  setAvatar: User;
  signUp: AuthUserPayload;
  signUpUser: AuthUserPayload;
  syncPalaceAccount: Scalars['Boolean'];
  updateCompany: Company;
  updateInspection: Inspection;
  updatePalaceAccount: Palace;
  updateUserPassword: Scalars['Boolean'];
};


export type MutationAddInspectionArgs = {
  input: AddInspectionInput;
};


export type MutationAddMessageToChatArgs = {
  input: CreateMessageInput;
};


export type MutationAttachFilesToPropertyArgs = {
  input: AttachFilesToPropertyInput;
};


export type MutationCheckPalaceConnectionArgs = {
  input: CheckPalaceConnectionInput;
};


export type MutationCreateChatArgs = {
  input: CreateChatInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateOfficeArgs = {
  input: CreateOfficeInput;
};


export type MutationCreatePalaceArgs = {
  input: CreatePalaceInput;
};


export type MutationInviteUserArgs = {
  id: Scalars['ID'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationSendFrontendErrorArgs = {
  error: Scalars['String'];
};


export type MutationSendHelpEnquiryArgs = {
  message: Scalars['String'];
};


export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String'];
};


export type MutationSetAvatarArgs = {
  image: Scalars['Upload'];
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSignUpUserArgs = {
  input: SignUpUserInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateInspectionArgs = {
  input: UpdateInspectionInput;
};


export type MutationUpdatePalaceAccountArgs = {
  input: UpdatePalaceAccountInput;
};


export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};

export type Office = {
  __typename?: 'Office';
  address: Scalars['String'];
  company: Company;
  historicalStatistics: Array<HistoricalUserStatistics>;
  id: Scalars['ID'];
  landlords: Array<Landlord>;
  palace?: Maybe<Palace>;
  properties: Array<Property>;
  propertyManagers: Array<PropertyManager>;
  tenancies: Array<Tenancy>;
  tenants: Array<Tenant>;
};

export type PaginationInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type PaginationPayload = {
  __typename?: 'PaginationPayload';
  totalItems: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type Palace = {
  __typename?: 'Palace';
  id: Scalars['ID'];
  office: Office;
  synchronizedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
};

export type PropertiesInput = {
  search?: Maybe<Scalars['String']>;
};

export type Property = {
  __typename?: 'Property';
  amenities: Scalars['String'];
  availableDate?: Maybe<Scalars['DateTime']>;
  bathrooms: Scalars['Float'];
  bedrooms: Scalars['Float'];
  bondBalance: Scalars['Float'];
  carParks: Scalars['Float'];
  changeCode: Scalars['Float'];
  city: Scalars['String'];
  class: Scalars['String'];
  commissionPercent: Scalars['Float'];
  country: Scalars['String'];
  currentBalance: Scalars['Float'];
  customFields: Array<CustomField>;
  description: Scalars['String'];
  disbursementsMax: Scalars['Float'];
  documents?: Maybe<Array<Attachment>>;
  ensuites: Scalars['Float'];
  featureDetails: Scalars['String'];
  floorArea: Scalars['Float'];
  furnishings: Scalars['String'];
  geographicLocation?: Maybe<Scalars['String']>;
  grid: Scalars['String'];
  id: Scalars['ID'];
  images: Array<Image>;
  inspections: Array<Inspection>;
  isAddressPublished: Scalars['Boolean'];
  isDisbursementsLimited: Scalars['Boolean'];
  isEntryPublished: Scalars['Boolean'];
  isNewConstruction: Scalars['Boolean'];
  isPetsAllowed: Scalars['Boolean'];
  isSmokersAllowed: Scalars['Boolean'];
  keepBackAccumulationAmount: Scalars['Float'];
  keepBackAmount: Scalars['Float'];
  keepBackReason: Scalars['String'];
  keyAccess: Scalars['String'];
  keyNo: Scalars['String'];
  laAccountNo: Scalars['String'];
  landArea: Scalars['Float'];
  landlord?: Maybe<Landlord>;
  lastTransactionDate?: Maybe<Scalars['DateTime']>;
  maintenanceFeePercent: Scalars['Float'];
  managementType: Scalars['String'];
  marketValue: Scalars['Float'];
  name: Scalars['String'];
  office: Office;
  openingBalance: Scalars['Float'];
  ourCode: Scalars['String'];
  palaceCode: Scalars['String'];
  parkingDescription: Scalars['String'];
  phone: Scalars['String'];
  postCode: Scalars['String'];
  propertyAddressLines: Array<Scalars['String']>;
  propertyManager?: Maybe<PropertyManager>;
  rentAmount: Scalars['Float'];
  rentalPeriod: Scalars['String'];
  sortCode: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stories: Scalars['String'];
  street: Scalars['String'];
  streetNumber: Scalars['String'];
  suburb: Scalars['String'];
  tenancies: Array<Tenancy>;
  thumbnail: Scalars['String'];
  unit: Scalars['String'];
  valuation?: Maybe<Scalars['Float']>;
  virtualTourUrl: Scalars['String'];
  webLinkUrl: Scalars['String'];
  workOrders: Array<WorkOrder>;
  yearBuilt: Scalars['Float'];
};

export type PropertyManager = {
  __typename?: 'PropertyManager';
  currentBalance?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  office: Office;
  propertyCount?: Maybe<Scalars['Float']>;
  user: User;
};

export type Query = {
  __typename?: 'Query';
  balanceHistory: Array<HistoricalUserStatistics>;
  chats: Array<Chat>;
  company?: Maybe<Company>;
  inspections: InspectionsPayload;
  invite: User;
  landlordHistory: Array<HistoricalUserStatistics>;
  messages: Array<Message>;
  office: Office;
  offices: Array<Office>;
  properties: Array<Property>;
  property?: Maybe<Property>;
  propertyHistory: Array<HistoricalUserStatistics>;
  user: User;
  users: UsersPayload;
  workOrders: WorkOrdersPayload;
};


export type QueryInspectionsArgs = {
  pagination?: Maybe<PaginationInput>;
  propertyId?: Maybe<Scalars['ID']>;
};


export type QueryInviteArgs = {
  token: Scalars['String'];
};


export type QueryMessagesArgs = {
  chatId: Scalars['ID'];
};


export type QueryPropertiesArgs = {
  input?: Maybe<PropertiesInput>;
};


export type QueryPropertyArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  input?: Maybe<UsersInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryWorkOrdersArgs = {
  pagination?: Maybe<PaginationInput>;
  propertyId?: Maybe<Scalars['ID']>;
};

export type SignUpInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  role: UserRole;
};

export type SignUpUserInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  chatMessageAdded: Message;
};


export type SubscriptionChatMessageAddedArgs = {
  chatId: Scalars['ID'];
};

export type Supplier = {
  __typename?: 'Supplier';
  address: Scalars['String'];
  changeCode: Scalars['Float'];
  comment: Scalars['String'];
  companyDescription: Scalars['String'];
  companyName: Scalars['String'];
  contactFirstName: Scalars['String'];
  contactLastName: Scalars['String'];
  currentBalance: Scalars['Float'];
  dearName: Scalars['String'];
  debits: Scalars['Float'];
  emails: Array<Scalars['String']>;
  fax: Scalars['String'];
  gstOrAbn: Scalars['String'];
  id: Scalars['ID'];
  initials: Scalars['String'];
  insuranceExpiryDate?: Maybe<Scalars['DateTime']>;
  invoiceNote: Scalars['String'];
  isCompany: Scalars['Boolean'];
  lastTransactionDate?: Maybe<Scalars['DateTime']>;
  mobile: Scalars['String'];
  openingBalance: Scalars['Float'];
  paymentType: Scalars['String'];
  payments: Scalars['Float'];
  phoneHome: Scalars['String'];
  phoneWork: Scalars['String'];
  serviceAddress: Scalars['String'];
  servicesOffered: Scalars['String'];
  statementMedia: Scalars['String'];
  systemBankCode: Scalars['String'];
  title: Scalars['String'];
};

export type TemporaryToken = {
  __typename?: 'TemporaryToken';
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  token: Scalars['String'];
  user: User;
};

export type Tenancy = {
  __typename?: 'Tenancy';
  bankCode: Scalars['String'];
  bondNumber: Scalars['String'];
  bondRequired: Scalars['String'];
  changeCode: Scalars['String'];
  contactAddress: Scalars['String'];
  contactEmail: Scalars['String'];
  contactFax: Scalars['String'];
  contactPhones: Array<Scalars['String']>;
  currentRent: Scalars['String'];
  dateEnded?: Maybe<Scalars['DateTime']>;
  dateStarted?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  idDebtor: Scalars['Boolean'];
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  leaseDateEnded?: Maybe<Scalars['DateTime']>;
  lettingFeeRequired: Scalars['Float'];
  name: Scalars['String'];
  note: Scalars['String'];
  office: Office;
  otherOwing: Scalars['Float'];
  outgoings: Scalars['Float'];
  rentOwing: Scalars['Float'];
  rentPaidToDate?: Maybe<Scalars['DateTime']>;
  rentPaidToLastMonth?: Maybe<Scalars['DateTime']>;
  rentPartPayment: Scalars['Float'];
  rentalPeriod: Scalars['String'];
  sortCode: Scalars['String'];
  tenants: Array<Tenant>;
};

export type Tenant = {
  __typename?: 'Tenant';
  addressPostal: Scalars['String'];
  addressService: Scalars['String'];
  customExtras?: Maybe<Array<Scalars['String']>>;
  dearName: Scalars['String'];
  email: Scalars['String'];
  fax: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  initials: Scalars['String'];
  isMainTenant: Scalars['Boolean'];
  lastName: Scalars['String'];
  office: Office;
  paymentMethod: Scalars['String'];
  phoneHome: Scalars['String'];
  phoneMobile: Scalars['String'];
  phoneWork: Scalars['String'];
  property: Property;
  propertyCount: Scalars['Float'];
  user: User;
};

export type UpdateCompanyInput = {
  logo?: Maybe<Scalars['Upload']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateInspectionInput = {
  attachments: Array<Scalars['Upload']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  issues: Array<InspectionIssueInput>;
  matterportUrl: Scalars['String'];
  property?: Maybe<Scalars['ID']>;
  propertyManager?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
  uploadedAttachments?: Maybe<Array<DocumentInput>>;
  youtubeUrl: Scalars['String'];
};

export type UpdatePalaceAccountInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UpdateUserPasswordInput = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  email: Scalars['String'];
  historicalStatistics: Array<HistoricalUserStatistics>;
  id: Scalars['ID'];
  isInvited: Scalars['Boolean'];
  isSignedUp: Scalars['Boolean'];
  landlord?: Maybe<Landlord>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  propertyManager?: Maybe<PropertyManager>;
  role: UserRole;
  temporaryToken: TemporaryToken;
  tenant?: Maybe<Tenant>;
};

export enum UserRole {
  Admin = 'Admin',
  Landlord = 'Landlord',
  PropertyManager = 'PropertyManager',
  Tenant = 'Tenant'
}

export type UsersInput = {
  role?: Maybe<UserRole>;
};

export type UsersPayload = {
  __typename?: 'UsersPayload';
  pagination?: Maybe<PaginationPayload>;
  users: Array<User>;
};

export type WorkOrder = {
  __typename?: 'WorkOrder';
  amount: Scalars['Float'];
  description: Scalars['String'];
  estimatedCost: Scalars['Float'];
  expense: Expense;
  hasFeesExcluded: Scalars['Boolean'];
  id: Scalars['ID'];
  invoiceDescription: Scalars['String'];
  jobAction: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  priority: Scalars['Float'];
  property?: Maybe<Property>;
  propertyManager?: Maybe<PropertyManager>;
  scheduledDate?: Maybe<Scalars['DateTime']>;
  supplier?: Maybe<Supplier>;
  tenancy?: Maybe<Tenancy>;
};

export type WorkOrdersPayload = {
  __typename?: 'WorkOrdersPayload';
  pagination: PaginationPayload;
  workOrders: Array<WorkOrder>;
};

export type UserFieldsFragment = { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined };

export type CompanyFieldsFragment = { __typename?: 'Company', id: string, logo?: string | null | undefined, name: string };

export type PropertyFieldsFragment = { __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined };

export type InspectionFieldsFragment = { __typename?: 'Inspection', date: any, description: string, id: string, matterportUrl?: string | null | undefined, youtubeUrl?: string | null | undefined, type: string, attachments?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined, issues: Array<{ __typename?: 'InspectionIssue', description: string, attachments: Array<{ __typename?: 'Attachment', name: string, url: string }> }> };

export type WorkOrderFieldsFragment = { __typename?: 'WorkOrder', description: string, invoiceDescription: string, id: string, amount: number, estimatedCost: number, hasFeesExcluded: boolean, jobAction: string, notes?: string | null | undefined, priority: number, scheduledDate?: any | null | undefined };

export type ExpenseFieldsFragment = { __typename?: 'Expense', id: string, name: string, description: string, accountType: string };

export type SupplierFieldsFragment = { __typename?: 'Supplier', id: string, address: string, changeCode: number, comment: string, companyDescription: string, companyName: string, contactFirstName: string, contactLastName: string, currentBalance: number, dearName: string, debits: number, emails: Array<string>, fax: string, gstOrAbn: string, initials: string, insuranceExpiryDate?: any | null | undefined, invoiceNote: string, isCompany: boolean, lastTransactionDate?: any | null | undefined, mobile: string, openingBalance: number, payments: number, paymentType: string, phoneHome: string, phoneWork: string, serviceAddress: string, servicesOffered: string, statementMedia: string, systemBankCode: string, title: string };

export type TenancyFieldsFragment = { __typename?: 'Tenancy', id: string, bankCode: string, bondNumber: string, bondRequired: string, changeCode: string, contactAddress: string, contactEmail: string, contactFax: string, contactPhones: Array<string>, currentRent: string, dateEnded?: any | null | undefined, dateStarted?: any | null | undefined, idDebtor: boolean, lastPaymentDate?: any | null | undefined, leaseDateEnded?: any | null | undefined, lettingFeeRequired: number, name: string, note: string, otherOwing: number, outgoings: number, rentalPeriod: string, rentOwing: number, rentPaidToDate?: any | null | undefined, rentPaidToLastMonth?: any | null | undefined, rentPartPayment: number, sortCode: string };

export type PropertyManagerFieldsFragment = { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined };

export type LandlordFieldsFragment = { __typename?: 'Landlord', id: string, propertyCount: number, currentBalance?: number | null | undefined };

export type TenantFieldsFragment = { __typename?: 'Tenant', id: string, addressPostal: string, addressService: string, customExtras?: Array<string> | null | undefined, dearName: string, email: string, fax: string, firstName: string, lastName: string, fullName: string, isMainTenant: boolean, initials: string, paymentMethod: string, phoneHome: string, phoneMobile: string, phoneWork: string, propertyCount: number };

export type PalaceFieldsFragment = { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined };

export type HistoricalUserStatisticsFieldsFragment = { __typename?: 'HistoricalUserStatistics', count: number, date: string, id: string, type: string };

export type PaginationFieldsFragment = { __typename?: 'PaginationPayload', totalItems: number, totalPages: number };

export type MessageFieldsFragment = { __typename?: 'Message', id: string, message: string, plainText?: string | null | undefined, isSeen?: boolean | null | undefined, createdAt: any, updatedAt: any };

export type ChatFieldsFragment = { __typename?: 'Chat', id: string };

export type OfficeFieldsFragment = { __typename?: 'Office', id: string, address: string, palace?: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } | null | undefined };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'AuthUserPayload', token: string, user: { __typename?: 'User', id: string, email: string } } };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: string, logo?: string | null | undefined, name: string } };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, logo?: string | null | undefined, name: string } };

export type CreateOfficeMutationVariables = Exact<{
  input: CreateOfficeInput;
}>;


export type CreateOfficeMutation = { __typename?: 'Mutation', createOffice: { __typename?: 'Office', address: string, id: string } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthUserPayload', token: string, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined, landlord?: { __typename?: 'Landlord', id: string, propertyCount: number, currentBalance?: number | null | undefined } | null | undefined, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined } | null | undefined, tenant?: { __typename?: 'Tenant', id: string, addressPostal: string, addressService: string, customExtras?: Array<string> | null | undefined, dearName: string, email: string, fax: string, firstName: string, lastName: string, fullName: string, isMainTenant: boolean, initials: string, paymentMethod: string, phoneHome: string, phoneMobile: string, phoneWork: string, propertyCount: number } | null | undefined, company?: { __typename?: 'Company', id: string, logo?: string | null | undefined, name: string, offices?: Array<{ __typename?: 'Office', id: string, address: string, palace?: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } | null | undefined }> | null | undefined } | null | undefined } } };

export type CheckPalaceConnectionMutationVariables = Exact<{
  input: CheckPalaceConnectionInput;
}>;


export type CheckPalaceConnectionMutation = { __typename?: 'Mutation', checkPalaceConnection: boolean };

export type CreatePalaceMutationVariables = Exact<{
  input: CreatePalaceInput;
}>;


export type CreatePalaceMutation = { __typename?: 'Mutation', createPalace: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } };

export type UpdatePalaceAccountMutationVariables = Exact<{
  input: UpdatePalaceAccountInput;
}>;


export type UpdatePalaceAccountMutation = { __typename?: 'Mutation', updatePalaceAccount: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } };

export type InviteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: boolean };

export type SignUpUserMutationVariables = Exact<{
  input: SignUpUserInput;
}>;


export type SignUpUserMutation = { __typename?: 'Mutation', signUpUser: { __typename?: 'AuthUserPayload', token: string, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined, landlord?: { __typename?: 'Landlord', id: string, propertyCount: number, currentBalance?: number | null | undefined } | null | undefined, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined } | null | undefined, tenant?: { __typename?: 'Tenant', id: string, addressPostal: string, addressService: string, customExtras?: Array<string> | null | undefined, dearName: string, email: string, fax: string, firstName: string, lastName: string, fullName: string, isMainTenant: boolean, initials: string, paymentMethod: string, phoneHome: string, phoneMobile: string, phoneWork: string, propertyCount: number } | null | undefined, company?: { __typename?: 'Company', id: string, logo?: string | null | undefined, name: string, offices?: Array<{ __typename?: 'Office', id: string, address: string, palace?: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } | null | undefined }> | null | undefined } | null | undefined } } };

export type AddInspectionMutationVariables = Exact<{
  input: AddInspectionInput;
}>;


export type AddInspectionMutation = { __typename?: 'Mutation', addInspection: { __typename?: 'Inspection', date: any, description: string, id: string, matterportUrl?: string | null | undefined, youtubeUrl?: string | null | undefined, type: string, attachments?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined, issues: Array<{ __typename?: 'InspectionIssue', description: string, attachments: Array<{ __typename?: 'Attachment', name: string, url: string }> }> } };

export type UpdateInspectionMutationVariables = Exact<{
  input: UpdateInspectionInput;
}>;


export type UpdateInspectionMutation = { __typename?: 'Mutation', updateInspection: { __typename?: 'Inspection', date: any, description: string, id: string, matterportUrl?: string | null | undefined, youtubeUrl?: string | null | undefined, type: string, attachments?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined, issues: Array<{ __typename?: 'InspectionIssue', description: string, attachments: Array<{ __typename?: 'Attachment', name: string, url: string }> }> } };

export type SetAvatarMutationVariables = Exact<{
  image: Scalars['Upload'];
}>;


export type SetAvatarMutation = { __typename?: 'Mutation', setAvatar: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined, landlord?: { __typename?: 'Landlord', id: string, propertyCount: number, currentBalance?: number | null | undefined } | null | undefined, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined } | null | undefined, tenant?: { __typename?: 'Tenant', id: string, addressPostal: string, addressService: string, customExtras?: Array<string> | null | undefined, dearName: string, email: string, fax: string, firstName: string, lastName: string, fullName: string, isMainTenant: boolean, initials: string, paymentMethod: string, phoneHome: string, phoneMobile: string, phoneWork: string, propertyCount: number } | null | undefined } };

export type AttachFilesToPropertyMutationVariables = Exact<{
  input: AttachFilesToPropertyInput;
}>;


export type AttachFilesToPropertyMutation = { __typename?: 'Mutation', attachFilesToProperty: { __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined } };

export type SendHelpEnquiryMutationVariables = Exact<{
  message: Scalars['String'];
}>;


export type SendHelpEnquiryMutation = { __typename?: 'Mutation', sendHelpEnquiry: boolean };

export type SendFrontendErrorMutationVariables = Exact<{
  error: Scalars['String'];
}>;


export type SendFrontendErrorMutation = { __typename?: 'Mutation', sendFrontendError: boolean };

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: boolean };

export type CreateChatMutationVariables = Exact<{
  input: CreateChatInput;
}>;


export type CreateChatMutation = { __typename?: 'Mutation', createChat: { __typename?: 'Chat', id: string } };

export type AddMessageToChatMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type AddMessageToChatMutation = { __typename?: 'Mutation', addMessageToChat: { __typename?: 'Message', id: string, message: string, plainText?: string | null | undefined, isSeen?: boolean | null | undefined, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } } };

export type UserInviteFragmentFragment = { __typename?: 'User', isInvited: boolean };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined, tenant?: { __typename?: 'Tenant', id: string, addressPostal: string, addressService: string, customExtras?: Array<string> | null | undefined, dearName: string, email: string, fax: string, firstName: string, lastName: string, fullName: string, isMainTenant: boolean, initials: string, paymentMethod: string, phoneHome: string, phoneMobile: string, phoneWork: string, propertyCount: number, property: { __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined } } | null | undefined, landlord?: { __typename?: 'Landlord', id: string, propertyCount: number, currentBalance?: number | null | undefined } | null | undefined, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined } | null | undefined } };

export type CompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, logo?: string | null | undefined, name: string, offices?: Array<{ __typename?: 'Office', id: string, address: string, palace?: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type OfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficesQuery = { __typename?: 'Query', offices: Array<{ __typename?: 'Office', id: string, address: string, palace?: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } | null | undefined }> };

export type PropertiesQueryVariables = Exact<{
  input?: Maybe<PropertiesInput>;
}>;


export type PropertiesQuery = { __typename?: 'Query', properties: Array<{ __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined }> };

export type PropertyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyQuery = { __typename?: 'Query', property?: { __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } } | null | undefined, landlord?: { __typename?: 'Landlord', id: string, propertyCount: number, currentBalance?: number | null | undefined, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } } | null | undefined, workOrders: Array<{ __typename?: 'WorkOrder', description: string, invoiceDescription: string, id: string, amount: number, estimatedCost: number, hasFeesExcluded: boolean, jobAction: string, notes?: string | null | undefined, priority: number, scheduledDate?: any | null | undefined, property?: { __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined } | null | undefined, expense: { __typename?: 'Expense', id: string, name: string, description: string, accountType: string }, supplier?: { __typename?: 'Supplier', id: string, address: string, changeCode: number, comment: string, companyDescription: string, companyName: string, contactFirstName: string, contactLastName: string, currentBalance: number, dearName: string, debits: number, emails: Array<string>, fax: string, gstOrAbn: string, initials: string, insuranceExpiryDate?: any | null | undefined, invoiceNote: string, isCompany: boolean, lastTransactionDate?: any | null | undefined, mobile: string, openingBalance: number, payments: number, paymentType: string, phoneHome: string, phoneWork: string, serviceAddress: string, servicesOffered: string, statementMedia: string, systemBankCode: string, title: string } | null | undefined, tenancy?: { __typename?: 'Tenancy', id: string, bankCode: string, bondNumber: string, bondRequired: string, changeCode: string, contactAddress: string, contactEmail: string, contactFax: string, contactPhones: Array<string>, currentRent: string, dateEnded?: any | null | undefined, dateStarted?: any | null | undefined, idDebtor: boolean, lastPaymentDate?: any | null | undefined, leaseDateEnded?: any | null | undefined, lettingFeeRequired: number, name: string, note: string, otherOwing: number, outgoings: number, rentalPeriod: string, rentOwing: number, rentPaidToDate?: any | null | undefined, rentPaidToLastMonth?: any | null | undefined, rentPartPayment: number, sortCode: string } | null | undefined, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } } | null | undefined }>, tenancies: Array<{ __typename?: 'Tenancy', id: string, bankCode: string, bondNumber: string, bondRequired: string, changeCode: string, contactAddress: string, contactEmail: string, contactFax: string, contactPhones: Array<string>, currentRent: string, dateEnded?: any | null | undefined, dateStarted?: any | null | undefined, idDebtor: boolean, lastPaymentDate?: any | null | undefined, leaseDateEnded?: any | null | undefined, lettingFeeRequired: number, name: string, note: string, otherOwing: number, outgoings: number, rentalPeriod: string, rentOwing: number, rentPaidToDate?: any | null | undefined, rentPaidToLastMonth?: any | null | undefined, rentPartPayment: number, sortCode: string, tenants: Array<{ __typename?: 'Tenant', id: string, addressPostal: string, addressService: string, customExtras?: Array<string> | null | undefined, dearName: string, email: string, fax: string, firstName: string, lastName: string, fullName: string, isMainTenant: boolean, initials: string, paymentMethod: string, phoneHome: string, phoneMobile: string, phoneWork: string, propertyCount: number }> }>, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined } | null | undefined };

export type UsersQueryVariables = Exact<{
  input?: Maybe<UsersInput>;
  pagination?: Maybe<PaginationInput>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersPayload', users: Array<{ __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined, landlord?: { __typename?: 'Landlord', id: string, propertyCount: number, currentBalance?: number | null | undefined } | null | undefined, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined } | null | undefined, tenant?: { __typename?: 'Tenant', id: string, addressPostal: string, addressService: string, customExtras?: Array<string> | null | undefined, dearName: string, email: string, fax: string, firstName: string, lastName: string, fullName: string, isMainTenant: boolean, initials: string, paymentMethod: string, phoneHome: string, phoneMobile: string, phoneWork: string, propertyCount: number } | null | undefined }>, pagination?: { __typename?: 'PaginationPayload', totalItems: number, totalPages: number } | null | undefined } };

export type InviteQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type InviteQuery = { __typename?: 'Query', invite: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } };

export type InspectionsQueryVariables = Exact<{
  propertyId?: Maybe<Scalars['ID']>;
  pagination?: Maybe<PaginationInput>;
}>;


export type InspectionsQuery = { __typename?: 'Query', inspections: { __typename?: 'InspectionsPayload', inspections: Array<{ __typename?: 'Inspection', date: any, description: string, id: string, matterportUrl?: string | null | undefined, youtubeUrl?: string | null | undefined, type: string, property: { __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined }, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } } | null | undefined, attachments?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined, issues: Array<{ __typename?: 'InspectionIssue', description: string, attachments: Array<{ __typename?: 'Attachment', name: string, url: string }> }> }>, pagination: { __typename?: 'PaginationPayload', totalItems: number, totalPages: number } } };

export type WorkOrdersQueryVariables = Exact<{
  pagination?: Maybe<PaginationInput>;
  propertyId?: Maybe<Scalars['ID']>;
}>;


export type WorkOrdersQuery = { __typename?: 'Query', workOrders: { __typename?: 'WorkOrdersPayload', workOrders: Array<{ __typename?: 'WorkOrder', description: string, invoiceDescription: string, id: string, amount: number, estimatedCost: number, hasFeesExcluded: boolean, jobAction: string, notes?: string | null | undefined, priority: number, scheduledDate?: any | null | undefined, property?: { __typename?: 'Property', id: string, name: string, description: string, status: string, currentBalance: number, unit: string, streetNumber: string, street: string, palaceCode: string, suburb: string, city: string, country: string, availableDate?: any | null | undefined, bedrooms: number, bathrooms: number, floorArea: number, geographicLocation?: string | null | undefined, landArea: number, carParks: number, startDate?: any | null | undefined, bondBalance: number, images: Array<{ __typename?: 'Image', title: string, url: string }>, documents?: Array<{ __typename?: 'Attachment', name: string, url: string }> | null | undefined } | null | undefined, expense: { __typename?: 'Expense', id: string, name: string, description: string, accountType: string }, supplier?: { __typename?: 'Supplier', id: string, address: string, changeCode: number, comment: string, companyDescription: string, companyName: string, contactFirstName: string, contactLastName: string, currentBalance: number, dearName: string, debits: number, emails: Array<string>, fax: string, gstOrAbn: string, initials: string, insuranceExpiryDate?: any | null | undefined, invoiceNote: string, isCompany: boolean, lastTransactionDate?: any | null | undefined, mobile: string, openingBalance: number, payments: number, paymentType: string, phoneHome: string, phoneWork: string, serviceAddress: string, servicesOffered: string, statementMedia: string, systemBankCode: string, title: string } | null | undefined, tenancy?: { __typename?: 'Tenancy', id: string, bankCode: string, bondNumber: string, bondRequired: string, changeCode: string, contactAddress: string, contactEmail: string, contactFax: string, contactPhones: Array<string>, currentRent: string, dateEnded?: any | null | undefined, dateStarted?: any | null | undefined, idDebtor: boolean, lastPaymentDate?: any | null | undefined, leaseDateEnded?: any | null | undefined, lettingFeeRequired: number, name: string, note: string, otherOwing: number, outgoings: number, rentalPeriod: string, rentOwing: number, rentPaidToDate?: any | null | undefined, rentPaidToLastMonth?: any | null | undefined, rentPartPayment: number, sortCode: string } | null | undefined, propertyManager?: { __typename?: 'PropertyManager', id: string, propertyCount?: number | null | undefined, currentBalance?: number | null | undefined, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } } | null | undefined }>, pagination: { __typename?: 'PaginationPayload', totalItems: number, totalPages: number } } };

export type LandlordHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type LandlordHistoryQuery = { __typename?: 'Query', landlordHistory: Array<{ __typename?: 'HistoricalUserStatistics', count: number, date: string, id: string, type: string }> };

export type PropertyHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyHistoryQuery = { __typename?: 'Query', propertyHistory: Array<{ __typename?: 'HistoricalUserStatistics', count: number, date: string, id: string, type: string }> };

export type BalanceHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type BalanceHistoryQuery = { __typename?: 'Query', balanceHistory: Array<{ __typename?: 'HistoricalUserStatistics', count: number, date: string, id: string, type: string }> };

export type ChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatsQuery = { __typename?: 'Query', chats: Array<{ __typename?: 'Chat', id: string, messages: Array<{ __typename?: 'Message', id: string, message: string, plainText?: string | null | undefined, isSeen?: boolean | null | undefined, createdAt: any, updatedAt: any }>, users: Array<{ __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined }> }> };

export type MessagesQueryVariables = Exact<{
  chatId: Scalars['ID'];
}>;


export type MessagesQuery = { __typename?: 'Query', messages: Array<{ __typename?: 'Message', id: string, message: string, plainText?: string | null | undefined, isSeen?: boolean | null | undefined, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } }> };

export type OfficeQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficeQuery = { __typename?: 'Query', office: { __typename?: 'Office', id: string, address: string, palace?: { __typename?: 'Palace', synchronizedAt?: any | null | undefined, id: string, version?: string | null | undefined } | null | undefined } };

export type ChatMessageAddedSubscriptionVariables = Exact<{
  chatId: Scalars['ID'];
}>;


export type ChatMessageAddedSubscription = { __typename?: 'Subscription', chatMessageAdded: { __typename?: 'Message', id: string, message: string, plainText?: string | null | undefined, isSeen?: boolean | null | undefined, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: string, role: UserRole, email: string, name: string, isInvited: boolean, isSignedUp: boolean, avatar?: string | null | undefined, phone?: string | null | undefined } } };

export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  role
  email
  name
  isInvited
  isSignedUp
  avatar
  phone
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on Company {
  id
  logo
  name
}
    `;
export const PropertyFieldsFragmentDoc = gql`
    fragment PropertyFields on Property {
  id
  images {
    title
    url
  }
  name
  description
  status
  currentBalance
  unit
  streetNumber
  street
  palaceCode
  suburb
  city
  country
  availableDate
  bedrooms
  bathrooms
  floorArea
  geographicLocation
  landArea
  carParks
  startDate
  bondBalance
  documents {
    name
    url
  }
}
    `;
export const InspectionFieldsFragmentDoc = gql`
    fragment InspectionFields on Inspection {
  attachments {
    name
    url
  }
  date
  description
  id
  issues {
    description
    attachments {
      name
      url
    }
  }
  matterportUrl
  youtubeUrl
  type
}
    `;
export const WorkOrderFieldsFragmentDoc = gql`
    fragment WorkOrderFields on WorkOrder {
  description
  invoiceDescription
  id
  amount
  estimatedCost
  hasFeesExcluded
  jobAction
  notes
  priority
  scheduledDate
}
    `;
export const ExpenseFieldsFragmentDoc = gql`
    fragment ExpenseFields on Expense {
  id
  name
  description
  accountType
}
    `;
export const SupplierFieldsFragmentDoc = gql`
    fragment SupplierFields on Supplier {
  id
  address
  changeCode
  comment
  companyDescription
  companyName
  contactFirstName
  contactLastName
  currentBalance
  dearName
  debits
  emails
  fax
  gstOrAbn
  initials
  insuranceExpiryDate
  invoiceNote
  isCompany
  lastTransactionDate
  mobile
  openingBalance
  payments
  paymentType
  phoneHome
  phoneWork
  serviceAddress
  servicesOffered
  statementMedia
  systemBankCode
  title
}
    `;
export const TenancyFieldsFragmentDoc = gql`
    fragment TenancyFields on Tenancy {
  id
  bankCode
  bondNumber
  bondRequired
  changeCode
  contactAddress
  contactEmail
  contactFax
  contactPhones
  currentRent
  dateEnded
  dateStarted
  idDebtor
  lastPaymentDate
  leaseDateEnded
  lettingFeeRequired
  name
  note
  otherOwing
  outgoings
  rentalPeriod
  rentOwing
  rentPaidToDate
  rentPaidToLastMonth
  rentPartPayment
  sortCode
}
    `;
export const PropertyManagerFieldsFragmentDoc = gql`
    fragment PropertyManagerFields on PropertyManager {
  id
  propertyCount
  currentBalance
}
    `;
export const LandlordFieldsFragmentDoc = gql`
    fragment LandlordFields on Landlord {
  id
  propertyCount
  currentBalance
}
    `;
export const TenantFieldsFragmentDoc = gql`
    fragment TenantFields on Tenant {
  id
  addressPostal
  addressService
  customExtras
  dearName
  email
  fax
  firstName
  lastName
  fullName
  isMainTenant
  initials
  paymentMethod
  phoneHome
  phoneMobile
  phoneWork
  propertyCount
}
    `;
export const HistoricalUserStatisticsFieldsFragmentDoc = gql`
    fragment HistoricalUserStatisticsFields on HistoricalUserStatistics {
  count
  date
  id
  type
}
    `;
export const PaginationFieldsFragmentDoc = gql`
    fragment PaginationFields on PaginationPayload {
  totalItems
  totalPages
}
    `;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  id
  message
  plainText
  isSeen
  createdAt
  updatedAt
}
    `;
export const ChatFieldsFragmentDoc = gql`
    fragment ChatFields on Chat {
  id
}
    `;
export const PalaceFieldsFragmentDoc = gql`
    fragment PalaceFields on Palace {
  synchronizedAt
  id
  version
}
    `;
export const OfficeFieldsFragmentDoc = gql`
    fragment OfficeFields on Office {
  id
  address
  palace {
    ...PalaceFields
  }
}
    ${PalaceFieldsFragmentDoc}`;
export const UserInviteFragmentFragmentDoc = gql`
    fragment UserInviteFragment on User {
  isInvited
}
    `;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    token
    user {
      id
      email
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const CreateOfficeDocument = gql`
    mutation CreateOffice($input: CreateOfficeInput!) {
  createOffice(input: $input) {
    address
    id
  }
}
    `;
export type CreateOfficeMutationFn = Apollo.MutationFunction<CreateOfficeMutation, CreateOfficeMutationVariables>;

/**
 * __useCreateOfficeMutation__
 *
 * To run a mutation, you first call `useCreateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfficeMutation, { data, loading, error }] = useCreateOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfficeMutation, CreateOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfficeMutation, CreateOfficeMutationVariables>(CreateOfficeDocument, options);
      }
export type CreateOfficeMutationHookResult = ReturnType<typeof useCreateOfficeMutation>;
export type CreateOfficeMutationResult = Apollo.MutationResult<CreateOfficeMutation>;
export type CreateOfficeMutationOptions = Apollo.BaseMutationOptions<CreateOfficeMutation, CreateOfficeMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    token
    user {
      ...UserFields
      landlord {
        ...LandlordFields
      }
      propertyManager {
        ...PropertyManagerFields
      }
      tenant {
        ...TenantFields
      }
      company {
        ...CompanyFields
        offices {
          ...OfficeFields
          palace {
            ...PalaceFields
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${LandlordFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}
${TenantFieldsFragmentDoc}
${CompanyFieldsFragmentDoc}
${OfficeFieldsFragmentDoc}
${PalaceFieldsFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const CheckPalaceConnectionDocument = gql`
    mutation CheckPalaceConnection($input: CheckPalaceConnectionInput!) {
  checkPalaceConnection(input: $input)
}
    `;
export type CheckPalaceConnectionMutationFn = Apollo.MutationFunction<CheckPalaceConnectionMutation, CheckPalaceConnectionMutationVariables>;

/**
 * __useCheckPalaceConnectionMutation__
 *
 * To run a mutation, you first call `useCheckPalaceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPalaceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPalaceConnectionMutation, { data, loading, error }] = useCheckPalaceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckPalaceConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CheckPalaceConnectionMutation, CheckPalaceConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckPalaceConnectionMutation, CheckPalaceConnectionMutationVariables>(CheckPalaceConnectionDocument, options);
      }
export type CheckPalaceConnectionMutationHookResult = ReturnType<typeof useCheckPalaceConnectionMutation>;
export type CheckPalaceConnectionMutationResult = Apollo.MutationResult<CheckPalaceConnectionMutation>;
export type CheckPalaceConnectionMutationOptions = Apollo.BaseMutationOptions<CheckPalaceConnectionMutation, CheckPalaceConnectionMutationVariables>;
export const CreatePalaceDocument = gql`
    mutation CreatePalace($input: CreatePalaceInput!) {
  createPalace(input: $input) {
    ...PalaceFields
  }
}
    ${PalaceFieldsFragmentDoc}`;
export type CreatePalaceMutationFn = Apollo.MutationFunction<CreatePalaceMutation, CreatePalaceMutationVariables>;

/**
 * __useCreatePalaceMutation__
 *
 * To run a mutation, you first call `useCreatePalaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePalaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPalaceMutation, { data, loading, error }] = useCreatePalaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePalaceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePalaceMutation, CreatePalaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePalaceMutation, CreatePalaceMutationVariables>(CreatePalaceDocument, options);
      }
export type CreatePalaceMutationHookResult = ReturnType<typeof useCreatePalaceMutation>;
export type CreatePalaceMutationResult = Apollo.MutationResult<CreatePalaceMutation>;
export type CreatePalaceMutationOptions = Apollo.BaseMutationOptions<CreatePalaceMutation, CreatePalaceMutationVariables>;
export const UpdatePalaceAccountDocument = gql`
    mutation UpdatePalaceAccount($input: UpdatePalaceAccountInput!) {
  updatePalaceAccount(input: $input) {
    ...PalaceFields
  }
}
    ${PalaceFieldsFragmentDoc}`;
export type UpdatePalaceAccountMutationFn = Apollo.MutationFunction<UpdatePalaceAccountMutation, UpdatePalaceAccountMutationVariables>;

/**
 * __useUpdatePalaceAccountMutation__
 *
 * To run a mutation, you first call `useUpdatePalaceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePalaceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePalaceAccountMutation, { data, loading, error }] = useUpdatePalaceAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePalaceAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePalaceAccountMutation, UpdatePalaceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePalaceAccountMutation, UpdatePalaceAccountMutationVariables>(UpdatePalaceAccountDocument, options);
      }
export type UpdatePalaceAccountMutationHookResult = ReturnType<typeof useUpdatePalaceAccountMutation>;
export type UpdatePalaceAccountMutationResult = Apollo.MutationResult<UpdatePalaceAccountMutation>;
export type UpdatePalaceAccountMutationOptions = Apollo.BaseMutationOptions<UpdatePalaceAccountMutation, UpdatePalaceAccountMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($id: ID!) {
  inviteUser(id: $id)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const SignUpUserDocument = gql`
    mutation SignUpUser($input: SignUpUserInput!) {
  signUpUser(input: $input) {
    token
    user {
      ...UserFields
      landlord {
        ...LandlordFields
      }
      propertyManager {
        ...PropertyManagerFields
      }
      tenant {
        ...TenantFields
      }
      company {
        ...CompanyFields
        offices {
          ...OfficeFields
          palace {
            ...PalaceFields
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${LandlordFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}
${TenantFieldsFragmentDoc}
${CompanyFieldsFragmentDoc}
${OfficeFieldsFragmentDoc}
${PalaceFieldsFragmentDoc}`;
export type SignUpUserMutationFn = Apollo.MutationFunction<SignUpUserMutation, SignUpUserMutationVariables>;

/**
 * __useSignUpUserMutation__
 *
 * To run a mutation, you first call `useSignUpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUserMutation, { data, loading, error }] = useSignUpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpUserMutation(baseOptions?: Apollo.MutationHookOptions<SignUpUserMutation, SignUpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpUserMutation, SignUpUserMutationVariables>(SignUpUserDocument, options);
      }
export type SignUpUserMutationHookResult = ReturnType<typeof useSignUpUserMutation>;
export type SignUpUserMutationResult = Apollo.MutationResult<SignUpUserMutation>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<SignUpUserMutation, SignUpUserMutationVariables>;
export const AddInspectionDocument = gql`
    mutation AddInspection($input: AddInspectionInput!) {
  addInspection(input: $input) {
    ...InspectionFields
  }
}
    ${InspectionFieldsFragmentDoc}`;
export type AddInspectionMutationFn = Apollo.MutationFunction<AddInspectionMutation, AddInspectionMutationVariables>;

/**
 * __useAddInspectionMutation__
 *
 * To run a mutation, you first call `useAddInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInspectionMutation, { data, loading, error }] = useAddInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInspectionMutation(baseOptions?: Apollo.MutationHookOptions<AddInspectionMutation, AddInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInspectionMutation, AddInspectionMutationVariables>(AddInspectionDocument, options);
      }
export type AddInspectionMutationHookResult = ReturnType<typeof useAddInspectionMutation>;
export type AddInspectionMutationResult = Apollo.MutationResult<AddInspectionMutation>;
export type AddInspectionMutationOptions = Apollo.BaseMutationOptions<AddInspectionMutation, AddInspectionMutationVariables>;
export const UpdateInspectionDocument = gql`
    mutation UpdateInspection($input: UpdateInspectionInput!) {
  updateInspection(input: $input) {
    ...InspectionFields
  }
}
    ${InspectionFieldsFragmentDoc}`;
export type UpdateInspectionMutationFn = Apollo.MutationFunction<UpdateInspectionMutation, UpdateInspectionMutationVariables>;

/**
 * __useUpdateInspectionMutation__
 *
 * To run a mutation, you first call `useUpdateInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectionMutation, { data, loading, error }] = useUpdateInspectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInspectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectionMutation, UpdateInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInspectionMutation, UpdateInspectionMutationVariables>(UpdateInspectionDocument, options);
      }
export type UpdateInspectionMutationHookResult = ReturnType<typeof useUpdateInspectionMutation>;
export type UpdateInspectionMutationResult = Apollo.MutationResult<UpdateInspectionMutation>;
export type UpdateInspectionMutationOptions = Apollo.BaseMutationOptions<UpdateInspectionMutation, UpdateInspectionMutationVariables>;
export const SetAvatarDocument = gql`
    mutation SetAvatar($image: Upload!) {
  setAvatar(image: $image) {
    ...UserFields
    landlord {
      ...LandlordFields
    }
    propertyManager {
      ...PropertyManagerFields
    }
    tenant {
      ...TenantFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${LandlordFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}
${TenantFieldsFragmentDoc}`;
export type SetAvatarMutationFn = Apollo.MutationFunction<SetAvatarMutation, SetAvatarMutationVariables>;

/**
 * __useSetAvatarMutation__
 *
 * To run a mutation, you first call `useSetAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAvatarMutation, { data, loading, error }] = useSetAvatarMutation({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useSetAvatarMutation(baseOptions?: Apollo.MutationHookOptions<SetAvatarMutation, SetAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAvatarMutation, SetAvatarMutationVariables>(SetAvatarDocument, options);
      }
export type SetAvatarMutationHookResult = ReturnType<typeof useSetAvatarMutation>;
export type SetAvatarMutationResult = Apollo.MutationResult<SetAvatarMutation>;
export type SetAvatarMutationOptions = Apollo.BaseMutationOptions<SetAvatarMutation, SetAvatarMutationVariables>;
export const AttachFilesToPropertyDocument = gql`
    mutation AttachFilesToProperty($input: AttachFilesToPropertyInput!) {
  attachFilesToProperty(input: $input) {
    ...PropertyFields
  }
}
    ${PropertyFieldsFragmentDoc}`;
export type AttachFilesToPropertyMutationFn = Apollo.MutationFunction<AttachFilesToPropertyMutation, AttachFilesToPropertyMutationVariables>;

/**
 * __useAttachFilesToPropertyMutation__
 *
 * To run a mutation, you first call `useAttachFilesToPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachFilesToPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachFilesToPropertyMutation, { data, loading, error }] = useAttachFilesToPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachFilesToPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AttachFilesToPropertyMutation, AttachFilesToPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachFilesToPropertyMutation, AttachFilesToPropertyMutationVariables>(AttachFilesToPropertyDocument, options);
      }
export type AttachFilesToPropertyMutationHookResult = ReturnType<typeof useAttachFilesToPropertyMutation>;
export type AttachFilesToPropertyMutationResult = Apollo.MutationResult<AttachFilesToPropertyMutation>;
export type AttachFilesToPropertyMutationOptions = Apollo.BaseMutationOptions<AttachFilesToPropertyMutation, AttachFilesToPropertyMutationVariables>;
export const SendHelpEnquiryDocument = gql`
    mutation SendHelpEnquiry($message: String!) {
  sendHelpEnquiry(message: $message)
}
    `;
export type SendHelpEnquiryMutationFn = Apollo.MutationFunction<SendHelpEnquiryMutation, SendHelpEnquiryMutationVariables>;

/**
 * __useSendHelpEnquiryMutation__
 *
 * To run a mutation, you first call `useSendHelpEnquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendHelpEnquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendHelpEnquiryMutation, { data, loading, error }] = useSendHelpEnquiryMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendHelpEnquiryMutation(baseOptions?: Apollo.MutationHookOptions<SendHelpEnquiryMutation, SendHelpEnquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendHelpEnquiryMutation, SendHelpEnquiryMutationVariables>(SendHelpEnquiryDocument, options);
      }
export type SendHelpEnquiryMutationHookResult = ReturnType<typeof useSendHelpEnquiryMutation>;
export type SendHelpEnquiryMutationResult = Apollo.MutationResult<SendHelpEnquiryMutation>;
export type SendHelpEnquiryMutationOptions = Apollo.BaseMutationOptions<SendHelpEnquiryMutation, SendHelpEnquiryMutationVariables>;
export const SendFrontendErrorDocument = gql`
    mutation SendFrontendError($error: String!) {
  sendFrontendError(error: $error)
}
    `;
export type SendFrontendErrorMutationFn = Apollo.MutationFunction<SendFrontendErrorMutation, SendFrontendErrorMutationVariables>;

/**
 * __useSendFrontendErrorMutation__
 *
 * To run a mutation, you first call `useSendFrontendErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFrontendErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFrontendErrorMutation, { data, loading, error }] = useSendFrontendErrorMutation({
 *   variables: {
 *      error: // value for 'error'
 *   },
 * });
 */
export function useSendFrontendErrorMutation(baseOptions?: Apollo.MutationHookOptions<SendFrontendErrorMutation, SendFrontendErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFrontendErrorMutation, SendFrontendErrorMutationVariables>(SendFrontendErrorDocument, options);
      }
export type SendFrontendErrorMutationHookResult = ReturnType<typeof useSendFrontendErrorMutation>;
export type SendFrontendErrorMutationResult = Apollo.MutationResult<SendFrontendErrorMutation>;
export type SendFrontendErrorMutationOptions = Apollo.BaseMutationOptions<SendFrontendErrorMutation, SendFrontendErrorMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($input: UpdateUserPasswordInput!) {
  updateUserPassword(input: $input)
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const CreateChatDocument = gql`
    mutation CreateChat($input: CreateChatInput!) {
  createChat(input: $input) {
    id
  }
}
    `;
export type CreateChatMutationFn = Apollo.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;
export const AddMessageToChatDocument = gql`
    mutation AddMessageToChat($input: CreateMessageInput!) {
  addMessageToChat(input: $input) {
    ...MessageFields
    user {
      ...UserFields
    }
  }
}
    ${MessageFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;
export type AddMessageToChatMutationFn = Apollo.MutationFunction<AddMessageToChatMutation, AddMessageToChatMutationVariables>;

/**
 * __useAddMessageToChatMutation__
 *
 * To run a mutation, you first call `useAddMessageToChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessageToChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageToChatMutation, { data, loading, error }] = useAddMessageToChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMessageToChatMutation(baseOptions?: Apollo.MutationHookOptions<AddMessageToChatMutation, AddMessageToChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMessageToChatMutation, AddMessageToChatMutationVariables>(AddMessageToChatDocument, options);
      }
export type AddMessageToChatMutationHookResult = ReturnType<typeof useAddMessageToChatMutation>;
export type AddMessageToChatMutationResult = Apollo.MutationResult<AddMessageToChatMutation>;
export type AddMessageToChatMutationOptions = Apollo.BaseMutationOptions<AddMessageToChatMutation, AddMessageToChatMutationVariables>;
export const UserDocument = gql`
    query User {
  user {
    ...UserFields
    tenant {
      ...TenantFields
      property {
        ...PropertyFields
      }
    }
    landlord {
      ...LandlordFields
    }
    propertyManager {
      ...PropertyManagerFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${TenantFieldsFragmentDoc}
${PropertyFieldsFragmentDoc}
${LandlordFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const CompanyDocument = gql`
    query Company {
  company {
    ...CompanyFields
    offices {
      ...OfficeFields
      palace {
        ...PalaceFields
      }
    }
  }
}
    ${CompanyFieldsFragmentDoc}
${OfficeFieldsFragmentDoc}
${PalaceFieldsFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyQuery(baseOptions?: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const OfficesDocument = gql`
    query Offices {
  offices {
    ...OfficeFields
    palace {
      ...PalaceFields
    }
  }
}
    ${OfficeFieldsFragmentDoc}
${PalaceFieldsFragmentDoc}`;

/**
 * __useOfficesQuery__
 *
 * To run a query within a React component, call `useOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfficesQuery(baseOptions?: Apollo.QueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, options);
      }
export function useOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, options);
        }
export type OfficesQueryHookResult = ReturnType<typeof useOfficesQuery>;
export type OfficesLazyQueryHookResult = ReturnType<typeof useOfficesLazyQuery>;
export type OfficesQueryResult = Apollo.QueryResult<OfficesQuery, OfficesQueryVariables>;
export const PropertiesDocument = gql`
    query Properties($input: PropertiesInput) {
  properties(input: $input) {
    ...PropertyFields
  }
}
    ${PropertyFieldsFragmentDoc}`;

/**
 * __usePropertiesQuery__
 *
 * To run a query within a React component, call `usePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePropertiesQuery(baseOptions?: Apollo.QueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
      }
export function usePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
        }
export type PropertiesQueryHookResult = ReturnType<typeof usePropertiesQuery>;
export type PropertiesLazyQueryHookResult = ReturnType<typeof usePropertiesLazyQuery>;
export type PropertiesQueryResult = Apollo.QueryResult<PropertiesQuery, PropertiesQueryVariables>;
export const PropertyDocument = gql`
    query Property($id: ID!) {
  property(id: $id) {
    ...PropertyFields
    propertyManager {
      ...PropertyManagerFields
      user {
        ...UserFields
      }
    }
    landlord {
      ...LandlordFields
      user {
        ...UserFields
      }
    }
    workOrders {
      ...WorkOrderFields
      property {
        ...PropertyFields
      }
      expense {
        ...ExpenseFields
      }
      supplier {
        ...SupplierFields
      }
      tenancy {
        ...TenancyFields
      }
      propertyManager {
        ...PropertyManagerFields
        user {
          ...UserFields
        }
      }
    }
    tenancies {
      ...TenancyFields
      tenants {
        ...TenantFields
      }
    }
  }
}
    ${PropertyFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${LandlordFieldsFragmentDoc}
${WorkOrderFieldsFragmentDoc}
${ExpenseFieldsFragmentDoc}
${SupplierFieldsFragmentDoc}
${TenancyFieldsFragmentDoc}
${TenantFieldsFragmentDoc}`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyQuery(baseOptions: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
      }
export function usePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
        }
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<typeof usePropertyLazyQuery>;
export type PropertyQueryResult = Apollo.QueryResult<PropertyQuery, PropertyQueryVariables>;
export const UsersDocument = gql`
    query Users($input: UsersInput, $pagination: PaginationInput) {
  users(input: $input, pagination: $pagination) {
    users {
      ...UserFields
      landlord {
        ...LandlordFields
      }
      propertyManager {
        ...PropertyManagerFields
      }
      tenant {
        ...TenantFields
      }
    }
    pagination {
      ...PaginationFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${LandlordFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}
${TenantFieldsFragmentDoc}
${PaginationFieldsFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const InviteDocument = gql`
    query Invite($token: String!) {
  invite(token: $token) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useInviteQuery__
 *
 * To run a query within a React component, call `useInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useInviteQuery(baseOptions: Apollo.QueryHookOptions<InviteQuery, InviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
      }
export function useInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
export type InviteQueryHookResult = ReturnType<typeof useInviteQuery>;
export type InviteLazyQueryHookResult = ReturnType<typeof useInviteLazyQuery>;
export type InviteQueryResult = Apollo.QueryResult<InviteQuery, InviteQueryVariables>;
export const InspectionsDocument = gql`
    query Inspections($propertyId: ID, $pagination: PaginationInput) {
  inspections(propertyId: $propertyId, pagination: $pagination) {
    inspections {
      ...InspectionFields
      property {
        ...PropertyFields
      }
      propertyManager {
        ...PropertyManagerFields
        user {
          ...UserFields
        }
      }
    }
    pagination {
      ...PaginationFields
    }
  }
}
    ${InspectionFieldsFragmentDoc}
${PropertyFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${PaginationFieldsFragmentDoc}`;

/**
 * __useInspectionsQuery__
 *
 * To run a query within a React component, call `useInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useInspectionsQuery(baseOptions?: Apollo.QueryHookOptions<InspectionsQuery, InspectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionsQuery, InspectionsQueryVariables>(InspectionsDocument, options);
      }
export function useInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionsQuery, InspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionsQuery, InspectionsQueryVariables>(InspectionsDocument, options);
        }
export type InspectionsQueryHookResult = ReturnType<typeof useInspectionsQuery>;
export type InspectionsLazyQueryHookResult = ReturnType<typeof useInspectionsLazyQuery>;
export type InspectionsQueryResult = Apollo.QueryResult<InspectionsQuery, InspectionsQueryVariables>;
export const WorkOrdersDocument = gql`
    query WorkOrders($pagination: PaginationInput, $propertyId: ID) {
  workOrders(pagination: $pagination, propertyId: $propertyId) {
    workOrders {
      ...WorkOrderFields
      property {
        ...PropertyFields
      }
      expense {
        ...ExpenseFields
      }
      supplier {
        ...SupplierFields
      }
      tenancy {
        ...TenancyFields
      }
      propertyManager {
        ...PropertyManagerFields
        user {
          ...UserFields
        }
      }
    }
    pagination {
      ...PaginationFields
    }
  }
}
    ${WorkOrderFieldsFragmentDoc}
${PropertyFieldsFragmentDoc}
${ExpenseFieldsFragmentDoc}
${SupplierFieldsFragmentDoc}
${TenancyFieldsFragmentDoc}
${PropertyManagerFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${PaginationFieldsFragmentDoc}`;

/**
 * __useWorkOrdersQuery__
 *
 * To run a query within a React component, call `useWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useWorkOrdersQuery(baseOptions?: Apollo.QueryHookOptions<WorkOrdersQuery, WorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrdersQuery, WorkOrdersQueryVariables>(WorkOrdersDocument, options);
      }
export function useWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrdersQuery, WorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrdersQuery, WorkOrdersQueryVariables>(WorkOrdersDocument, options);
        }
export type WorkOrdersQueryHookResult = ReturnType<typeof useWorkOrdersQuery>;
export type WorkOrdersLazyQueryHookResult = ReturnType<typeof useWorkOrdersLazyQuery>;
export type WorkOrdersQueryResult = Apollo.QueryResult<WorkOrdersQuery, WorkOrdersQueryVariables>;
export const LandlordHistoryDocument = gql`
    query LandlordHistory {
  landlordHistory {
    ...HistoricalUserStatisticsFields
  }
}
    ${HistoricalUserStatisticsFieldsFragmentDoc}`;

/**
 * __useLandlordHistoryQuery__
 *
 * To run a query within a React component, call `useLandlordHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandlordHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandlordHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandlordHistoryQuery(baseOptions?: Apollo.QueryHookOptions<LandlordHistoryQuery, LandlordHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandlordHistoryQuery, LandlordHistoryQueryVariables>(LandlordHistoryDocument, options);
      }
export function useLandlordHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandlordHistoryQuery, LandlordHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandlordHistoryQuery, LandlordHistoryQueryVariables>(LandlordHistoryDocument, options);
        }
export type LandlordHistoryQueryHookResult = ReturnType<typeof useLandlordHistoryQuery>;
export type LandlordHistoryLazyQueryHookResult = ReturnType<typeof useLandlordHistoryLazyQuery>;
export type LandlordHistoryQueryResult = Apollo.QueryResult<LandlordHistoryQuery, LandlordHistoryQueryVariables>;
export const PropertyHistoryDocument = gql`
    query PropertyHistory {
  propertyHistory {
    ...HistoricalUserStatisticsFields
  }
}
    ${HistoricalUserStatisticsFieldsFragmentDoc}`;

/**
 * __usePropertyHistoryQuery__
 *
 * To run a query within a React component, call `usePropertyHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyHistoryQuery(baseOptions?: Apollo.QueryHookOptions<PropertyHistoryQuery, PropertyHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyHistoryQuery, PropertyHistoryQueryVariables>(PropertyHistoryDocument, options);
      }
export function usePropertyHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyHistoryQuery, PropertyHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyHistoryQuery, PropertyHistoryQueryVariables>(PropertyHistoryDocument, options);
        }
export type PropertyHistoryQueryHookResult = ReturnType<typeof usePropertyHistoryQuery>;
export type PropertyHistoryLazyQueryHookResult = ReturnType<typeof usePropertyHistoryLazyQuery>;
export type PropertyHistoryQueryResult = Apollo.QueryResult<PropertyHistoryQuery, PropertyHistoryQueryVariables>;
export const BalanceHistoryDocument = gql`
    query BalanceHistory {
  balanceHistory {
    ...HistoricalUserStatisticsFields
  }
}
    ${HistoricalUserStatisticsFieldsFragmentDoc}`;

/**
 * __useBalanceHistoryQuery__
 *
 * To run a query within a React component, call `useBalanceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalanceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalanceHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalanceHistoryQuery(baseOptions?: Apollo.QueryHookOptions<BalanceHistoryQuery, BalanceHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalanceHistoryQuery, BalanceHistoryQueryVariables>(BalanceHistoryDocument, options);
      }
export function useBalanceHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalanceHistoryQuery, BalanceHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalanceHistoryQuery, BalanceHistoryQueryVariables>(BalanceHistoryDocument, options);
        }
export type BalanceHistoryQueryHookResult = ReturnType<typeof useBalanceHistoryQuery>;
export type BalanceHistoryLazyQueryHookResult = ReturnType<typeof useBalanceHistoryLazyQuery>;
export type BalanceHistoryQueryResult = Apollo.QueryResult<BalanceHistoryQuery, BalanceHistoryQueryVariables>;
export const ChatsDocument = gql`
    query Chats {
  chats {
    ...ChatFields
    messages(first: 1) {
      ...MessageFields
    }
    users {
      ...UserFields
    }
  }
}
    ${ChatFieldsFragmentDoc}
${MessageFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useChatsQuery__
 *
 * To run a query within a React component, call `useChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatsQuery(baseOptions?: Apollo.QueryHookOptions<ChatsQuery, ChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatsQuery, ChatsQueryVariables>(ChatsDocument, options);
      }
export function useChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatsQuery, ChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatsQuery, ChatsQueryVariables>(ChatsDocument, options);
        }
export type ChatsQueryHookResult = ReturnType<typeof useChatsQuery>;
export type ChatsLazyQueryHookResult = ReturnType<typeof useChatsLazyQuery>;
export type ChatsQueryResult = Apollo.QueryResult<ChatsQuery, ChatsQueryVariables>;
export const MessagesDocument = gql`
    query Messages($chatId: ID!) {
  messages(chatId: $chatId) {
    ...MessageFields
    user {
      ...UserFields
    }
  }
}
    ${MessageFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useMessagesQuery(baseOptions: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesQueryResult = Apollo.QueryResult<MessagesQuery, MessagesQueryVariables>;
export const OfficeDocument = gql`
    query Office {
  office {
    ...OfficeFields
  }
}
    ${OfficeFieldsFragmentDoc}`;

/**
 * __useOfficeQuery__
 *
 * To run a query within a React component, call `useOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfficeQuery(baseOptions?: Apollo.QueryHookOptions<OfficeQuery, OfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeQuery, OfficeQueryVariables>(OfficeDocument, options);
      }
export function useOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeQuery, OfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeQuery, OfficeQueryVariables>(OfficeDocument, options);
        }
export type OfficeQueryHookResult = ReturnType<typeof useOfficeQuery>;
export type OfficeLazyQueryHookResult = ReturnType<typeof useOfficeLazyQuery>;
export type OfficeQueryResult = Apollo.QueryResult<OfficeQuery, OfficeQueryVariables>;
export const ChatMessageAddedDocument = gql`
    subscription ChatMessageAdded($chatId: ID!) {
  chatMessageAdded(chatId: $chatId) {
    ...MessageFields
    user {
      ...UserFields
    }
  }
}
    ${MessageFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useChatMessageAddedSubscription__
 *
 * To run a query within a React component, call `useChatMessageAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessageAddedSubscription({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatMessageAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatMessageAddedSubscription, ChatMessageAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatMessageAddedSubscription, ChatMessageAddedSubscriptionVariables>(ChatMessageAddedDocument, options);
      }
export type ChatMessageAddedSubscriptionHookResult = ReturnType<typeof useChatMessageAddedSubscription>;
export type ChatMessageAddedSubscriptionResult = Apollo.SubscriptionResult<ChatMessageAddedSubscription>;